import React from 'react';
import { Flex, Padding } from 'components/base/layout-components';
import PieChart from 'components/PieChart';
import { CustomPieTooltip, MoreIssueTypesTooltip } from './tooltips';
import SummaryItemBox, {
  MAX_NUM_OF_SUMMARY_TYPES,
  SummaryItemMoreContainer
} from './SummaryItemBox';
import { getColor } from 'common/constants/_colors';
import Tooltip from '@material-ui/core/Tooltip';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import { ChartContainer } from './customCharts';
import ComposedStackBarLineChart from 'components/ComposedStackBarLineChart';
import styled from 'styled-components';
import PMReportWithPieSkeleton from 'images/PMReportWithPieSkeleton.svg';
import PMReportWithoutPieSkeleton from 'images/PMReportWithoutPieSkeleton.svg';

const SkeltonWrapper = styled.img`
  width: 100%;
`;

const StyledSkeletonContainer = styled(Padding)`
  overflow: auto;
`;

export const PMReportSkeleton = ({ showPie }) => (
  <StyledSkeletonContainer padding='big' t='large'>
    <SkeltonWrapper
      src={showPie ? PMReportWithPieSkeleton : PMReportWithoutPieSkeleton}
      alt=''
    />
  </StyledSkeletonContainer>
);

export const InvestmentPerTypePieSection = ({
  pieData,
  innerText,
  tableConfig,
  numOfTypes,
  numOfMore,
  moreTotalPercents,
  convertedMoreTotalDays
}) => {
  const summaryItemBoxes = tableConfig
    .filter(
      ({ dataPoint, isMoreIssueType }) =>
        dataPoint !== 'name' && !isMoreIssueType
    )
    .map(({ key, convertedTotalDays, percents, dataPoint, color }) => {
      return (
        <SummaryItemBox
          key={dataPoint}
          typeColor={getColor(color)}
          type={key}
          percents={percents}
          total={convertedTotalDays}
        />
      );
    });

  return (
    <Flex direction='row'>
      <Flex pr='large' items='center' justify='center'>
        <PieChart
          data={pieData}
          dataKey='value'
          innerText={innerText}
          customTooltip={<CustomPieTooltip />}
          tooltipType='investment-profile'
          pieSize={{ width: 200, height: 200 }}
        />
      </Flex>
      <Flex direction='column' grow='1' self='center'>
        <Flex direction='row' grow='1' self='center' width='100%'>
          {summaryItemBoxes}
          {numOfTypes > MAX_NUM_OF_SUMMARY_TYPES && (
            <Tooltip
              interactive
              placement='bottom-end'
              title={<MoreIssueTypesTooltip tableConfig={tableConfig} />}
            >
              <SummaryItemMoreContainer>
                <SummaryItemBox
                  displayType='more'
                  typeColor={getColor('shark')}
                  type={`${numOfMore} more types`}
                  percents={moreTotalPercents}
                  total={convertedMoreTotalDays}
                />
              </SummaryItemMoreContainer>
            </Tooltip>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export const InvestmentPerIssueTypeOverTimeSection = ({
  slicedIterations,
  chartConfig,
  customLineTootip,
  title
}) => {
  return (
    <>
      {title && (
        <Text size='large' pb={`${SPACES.medium}`}>
          {title}
        </Text>
      )}
      <Flex direction='row' justify='center'>
        <ChartContainer>
          <ComposedStackBarLineChart
            data={slicedIterations}
            config={chartConfig}
            {...(customLineTootip
              ? { customTooltip: customLineTootip }
              : { showTooltip: true })}
          />
        </ChartContainer>
      </Flex>
    </>
  );
};
